import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import CustomPagination from "../utils/paginationUtils";
import SearchIcon from "@mui/icons-material/Search";
import Select from "react-select";
import DeleteIcon from "../assets/deleteIcon.svg";
import { CircularProgress } from "@mui/material";
import HospitalSelect from "../selectFilters/HospitalSelect";
import "./HospitalSpecialityMapping.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { HospitalServices } from "../services/HospitalServices";
import AddNewMapping from "./AddNewMapping";
const HospitalSpecialityMapping = () => {
  const [isLoading, setLoading] = useState(false);
  const [hospitalId, setHospitalId] = useState(null);
  const [isNewMapping, setNewMapping] = useState(false);
  const [mappedSpeciality, setMappedSpeciality] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getSpecialityHospitalList = async () => {
    setLoading(true);
    try {
      const res = await HospitalServices.getHospitalSpecialityMapping(
        hospitalId?.value
      );

      setMappedSpeciality(res?.data?.list);
      setTotalPages(res?.data?.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };

  const handleRemove = async (id) => {
    try {
      const res = await HospitalServices.deleteHospitalSpecialityMapping(id);
      await getSpecialityHospitalList();
      window.alert(res?.data?.message);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    getSpecialityHospitalList();
  }, [hospitalId, page]);
  return (
    <div className="managespeciality-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Manage Speciality
      </span>
      <div className="flex items-center justify-between">
        <div className="heading">Manage Speciality </div>
        <div className="flex items-center gap-3">
          <div className="w-[300px]">
            <HospitalSelect
              onChange={setHospitalId}
              hospitalIds={hospitalId}
              isMulti={false}
            />
          </div>
          <div
            className="text-sm font-semibold text-[#017C57] bg-white border border-[#017C57] border-solid px-5 py-3 rounded-full cursor-pointer"
            onClick={() => {
              hospitalId?.value
                ? setNewMapping(true)
                : window.alert(
                    "Please Select Hospital Before Mapping Speciality"
                  );
            }}
          >
            Add New Mapping
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      {isLoading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className={`grid grid-cols-4  text-[#797979] text-[18px] px-8`}>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Speciality ID
              </div>
            </div>
            <div className="col-span-2">
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                Speciality Name
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">Action</div>
            </div>
          </div>
          {mappedSpeciality && mappedSpeciality?.length > 0 ? (
            mappedSpeciality?.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className={`py-6 px-8 rounded-[16px] ${
                    idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                  }`}
                >
                  {" "}
                  <div
                    className={`grid grid-cols-4  text-[#797979] text-[18px] `}
                  >
                    <div>
                      <div>{item?.specialityId}</div>
                    </div>
                    <div className="col-span-2">
                      <div>{item?.speciality}</div>
                    </div>
                    <div>
                      <img
                        src={DeleteIcon}
                        alt="delete-icon"
                        className="cursor-pointer"
                        onClick={() => {
                          console.log("delete clicked");
                          handleRemove(item.id);
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
              No Speciality Found
            </div>
          )}
        </div>
      )}

      {
        <div className="flex justify-center">
          <CustomPagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      }
      {isNewMapping && (
        <AddNewMapping
          setOpen={setNewMapping}
          selectedHospitalId={hospitalId.value}
        />
      )}
    </div>
  );
};

export default HospitalSpecialityMapping;
